import axiosClient from 'api/shared/AxiosClient';

class TeamUserService {

    getTeamUsers = async (params = {}) => {
        const query = new URLSearchParams();
        if (params.name)  query.set('name', params.name);
        if (params.role)  query.set('role', params.role);
        if (params.page)  query.set('page', params.page);
        if (params.limit) query.set('limit', params.limit);
        const resp = await axiosClient.get(`/teams?${query.toString()}`);
        return resp.data;
    }

    createTeamUser = async (data) => {
        const resp = await axiosClient.post('/teams', data);
        return resp.data;
    }

    updateTeamUser = async (id, data) => {
        const resp = await axiosClient.patch(`/teams/${id}`, data);
        return resp.data;
    }

    deleteTeamUser = async (id) => {
        await axiosClient.delete(`/teams/${id}`);
    }
}

const teamUserService = new TeamUserService();
export default teamUserService;
